
import { Link } from "react-router-dom";

export function ProjectLoading() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="border-b border-border/40 bg-stdly-blue backdrop-blur supports-[backdrop-filter]:bg-stdly-blue/90">
        <div className="container flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img 
              src="/lovable-uploads/1268e013-62c0-4efc-98ef-21ea816431fb.png" 
              alt="Standardly Logo" 
              className="h-8 w-auto" 
            />
          </Link>
        </div>
      </header>
      <main className="flex-1 container py-8">
        <div className="py-8 text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
          <p className="mt-2 text-muted-foreground">Loading project details...</p>
        </div>
      </main>
    </div>
  );
}
